import { Box } from '@hivebrite/design-system/Box';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

const LoadingCard = () => (
  <Box height="115px" display="block">
    <Skeleton height={30} width="30%" mt={1} />
    <Box mt={4}>
      <Skeleton height={50} width="90%" />
    </Box>
  </Box>
);

export default LoadingCard;
